<template>
  <v-sheet class="if-detaile-sheet">
    <div>
      <v-btn @click="backList()" text>
        <v-icon left color="blue darken-4">keyboard_arrow_left</v-icon>
        <span class="back-btn">一覧へ戻る</span>
      </v-btn>
    </div>
    <v-card class="com-pc-card detaile">
      <div class="com-pc-card-header if-detaile-header">
        <span class="com-pc-card-title">お知らせ情報詳細</span>
      </div>
      <div class="rslt-box">
        <div class="rslt-list">
          <v-simple-table fixed-header light class="info-label">
            <tbody>
              <tr>
                <td class="label">
                  {{ resultLabel.infoKind }}
                </td>
                <td>{{ dispInfo.infoKindName }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.area }}</td>
                <td>{{ dispInfo.areaName }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.target }}</td>
                <td>{{ dispInfo.target }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.summaryType }}</td>
                <td>{{ dispInfo.summaryCode }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.announceTime }}</td>
                <td>{{ dispInfo.announceTime }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.summary }}</td>
                <td>{{ dispInfo.summary }}</td>
              </tr>
              <tr>
                <td class="label">{{ resultLabel.body }}</td>
                <td class="detail-line">{{ dispInfo.detail }}</td>
              </tr>
              <tr v-if="relCd !== null">
                <td class="label">{{ resultLabel.relationObs }}</td>
                <td>
                  <a
                    v-for="(obs, index) in dispInfo.relObs"
                    :key="index"
                    class="obs-nm"
                    @click="obsDetail(obs.obsrvtnPointFullCode)"
                    >{{ obs.obsNm }}</a
                  >
                </td>
              </tr>
              <tr
                v-if="
                  dispRelObs !== null &&
                    dispRelObs.length < 2 &&
                    relCd !== null &&
                    dispRelObs[0].upstreamObsrvtnPointFullCode !== null
                "
              >
                <td class="label">{{ resultLabel.relationUpObs }}</td>
                <td>
                  <a
                    @click="
                      obsDetail(dispRelObs[0].upstreamObsrvtnPointFullCode)
                    "
                    >{{ dispRelObs[0].altObsNm }}</a
                  >
                </td>
              </tr>
              <tr
                v-if="
                  dispRelObs !== null &&
                    dispRelObs.length < 2 &&
                    relCd !== null &&
                    dispRelObs[0].cameraScamId !== null
                "
              >
                <td class="label">{{ resultLabel.cctvCamera }}</td>
                <td>
                  <v-col
                    class="pa-0"
                    v-if="
                      dispRelObs[0].cameraCurrProvUrl !== null ||
                        dispRelObs[0].cameraCurrentUrl !== null
                    "
                  >
                    <span
                      ><a class="camImg" @click="openDlg('live')"
                        >{{ dispRelObs[0].cameraNm }}（現状）</a
                      ></span
                    >
                  </v-col>
                  <v-col
                    class="pa-0"
                    v-if="
                      dispRelObs[0].cameraNormProvUrl !== null ||
                        dispRelObs[0].cameraNormallyUrl !== null
                    "
                  >
                    <span
                      ><a class="camImg" @click="openDlg('normal')"
                        >{{ dispRelObs[0].cameraNm }}（平常）</a
                      ></span
                    >
                  </v-col>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>

      <transition name="modal" appear v-if="showCam && selectCamera !== null">
        <div class="com-modal com-modal-overlay" @click="closeDlg">
          <v-card class="com-pc-card no-gutters guide-dialog">
            <v-row class="com-pc-card-header">
              <span class="com-pc-card-title">{{
                resultLabel.cctvCamera
              }}</span>
              <v-spacer></v-spacer>
              <v-btn text small icon color="white" @click="closeDlg">
                <v-icon>highlight_off</v-icon>
              </v-btn>
            </v-row>
            <v-col class="com-pc-card-contents">
              <v-sheet height="100%" tile>
                <v-row
                  class="fill-height mx-0 pa-1"
                  align="center"
                  justify="center"
                >
                  <v-img
                    v-if="
                      selectCamera === 'live' &&
                        dispRelObs[0].cameraCurrProvUrl !== null
                    "
                    :src="dispRelObs[0].cameraCurrProvUrl"
                    @error="altUrl"
                    class="cam-img"
                  />
                  <v-img
                    v-if="
                      selectCamera === 'live' &&
                        dispRelObs[0].cameraCurrProvUrl === null
                    "
                    :src="dispRelObs[0].cameraCurrentUrl"
                    class="cam-img"
                  />
                  <v-img
                    v-if="
                      selectCamera === 'normal' &&
                        dispRelObs[0].cameraNormProvUrl !== null
                    "
                    :src="dispRelObs[0].cameraNormProvUrl"
                    @error="altUrl"
                    class="cam-img"
                  />
                  <v-img
                    v-if="
                      selectCamera === 'normal' &&
                        dispRelObs[0].cameraNormProvUrl === null
                    "
                    :src="dispRelObs[0].cameraNormallyUrl"
                    class="cam-img"
                  />
                </v-row>
              </v-sheet>
            </v-col>
          </v-card>
        </div>
      </transition>
    </v-card>
  </v-sheet>
</template>
<script>
import PageLog from "./../../../lib/pageLog.js";
import mixin from "./../../../lib/mixin.js";
export default {
  mixins: [mixin],
  data() {
    return {
      // 表示用お知らせ詳細
      dispInfo: {},
      dispRelObs: null,
      relCd: null,
      showCam: false,
      selectCamera: null,
      resultLabel: {
        infoKind: "お知らせ種別",
        area: "地方",
        target: "お知らせ対象",
        summaryType: "お知らせ分類",
        announceTime: "発表日時",
        summary: "概要",
        body: "本文",
        relationObs: "お知らせ対象観測所",
        relationUpObs: "代替観測所",
        cctvCamera: "参照カメラ",
      },
    };
  },
  mounted() {
    // URLパラメータ取得
    var urlParam = this.$route.query["infmgcd"];
    this.getInformationInfo(urlParam);
    // アクセスログ出力
    PageLog.log({
      page_log: "info_detail",
      device_sb: "pc",
      fc_flg: this.$store.getters["app/isFldCtl"],
    });
  },

  computed: {
    /**
     * お知らせ詳細
     */
    informationInfo: {
      get() {
        return this.$store.state.info.informationInfo;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.info.infoParam;
      },
    },
  },
  watch: {
    // お知らせ詳細の変更の監視
    informationInfo() {
      this.setInformationInfo();
    },
  },
  methods: {
    backList() {
      let param = {
        infKnd: null,
        area: null,
        trgt: null,
        dvs: [],
      };
      if (this.reqParam) {
        param = {
          infKnd: this.reqParam.infoKind,
          area: this.reqParam.area,
          trgt: this.reqParam.target,
          dvs: this.reqParam.division,
        };
      }
      this.routerPushPcInfoList("/pcfull/info", param);
    },
    /**
     * お知らせ詳細取得
     */
    getInformationInfo(urlParam) {
      this.$store.dispatch("info/getInformationInfo", urlParam);
    },

    setInformationInfo() {
      if (!Object.keys(this.informationInfo).length) {
        // お知らせ管理番号に合致するお知らせ情報が見つからない場合は一覧に遷移する。
        this.backList();
      }
      // 変換後お知らせ詳細
      this.dispInfo = this.$store.getters["info/getInfo"];
      this.$nextTick().then(() => {
        this.dispRelObs = this.dispInfo.relObs;
        this.relCd = this.dispRelObs[0].obsrvtnPointFullCode;
      });
    },

    obsDetail(obsFcd) {
      let ofcCd = parseInt(obsFcd.substr(0, 5));
      let itmkndCd = parseInt(obsFcd.substr(5, 3));
      let obsCd = parseInt(obsFcd.substr(8, 5));
      let routeData = this.$router.resolve({
        name: "tm",
        query: {
          itmkndCd: itmkndCd,
          ofcCd: ofcCd,
          obsCd: obsCd,
          isCurrent: true,
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(routeData.href, "_self", "noreferrer,noopener");
    },
    openDlg(state) {
      this.showCam = true;
      this.selectCamera = state;
    },
    closeDlg() {
      this.showCam = false;
      this.selectCamera = null;
    },
    altUrl() {
      if (this.selectCamera === "live") {
        this.dispRelObs[0].cameraCurrProvUrl = this.dispRelObs[0].cameraCurrentUrl;
      } else if (this.selectCamera === "normal") {
        this.dispRelObs[0].cameraNormProvUrl = this.dispRelObs[0].cameraNormallyUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  width: 10%;
  font-weight: 600;
  min-width: 200px;
}
.camImg {
  text-decoration: none;
}
.cam-img {
  border: 0;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.obs-nm {
  margin-right: 12px;
}
.latestURL {
  padding-right: 8px;
}
.usualURL {
  padding-right: 8px;
}
.if-detaile-sheet {
  display: flex;
  flex-direction: column;
  height: 100%;
  .back-btn {
    color: blue;
  }
  .detaile {
    display: flex;
    flex-direction: column;
    height: 100%;
    .if-detaile-header {
      display: flex;
      // カードヘッダの高さ
      height: 40px;
      // カードのパディング
      padding-left: 12px;
      // カードヘッダの背景色
      background-color: #3041a5;
      align-items: center;
      margin-bottom: 8px;
    }
    .rslt-box {
      position: relative;
      flex: 1;
      height: 100%;
      .rslt-list {
        height: 100%;
        position: absolute;
        overflow: hidden;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        .info-label {
          height: 100%;
          & > :first-child {
            overflow-x: auto;
            overflow-y: auto;
            height: 100%;
          }
          .detail-line {
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
